import { DateTime } from 'luxon';

const INPUT_DATE_FORMAT = 'yyyy-MM-dd';

export const calculateAge = (isoString: string) => {
	return Math.abs(DateTime.fromISO(isoString).diffNow('years').years).toFixed(
		0
	);
};

export const dateNowInput = DateTime.now().toFormat(INPUT_DATE_FORMAT);
